import React from 'react';
import Footer from '../components/Footer';
import KontributorCard from '../components/KontributorCard';
import Navbar from '../components/Navbar';

export default function Kontributor() {
  return (
    <div>
      <div className="container mx-auto px-[4%]">
        <Navbar />
        <div className="grid grid-cols-2 gap-6 items-center">
          <div className="font-[Rubik]">
            <p className="text-5xl font-medium">Apa Keuntungan Saya Menjadi Kontributor</p>
            <p className="text-xl text-[#999999] mt-5">
              Berikut beberapa poin penting yang akan kamu dapat jika menjadi kontributor di expore
              Tegal
            </p>
            <div className="grid grid-cols-3 gap-4 my-14 text-center">
              <div className="flex flex-col items-center">
                <img src="/assets/images/icon-left.svg" alt="icon-left" />
                <h4 className="text-[#666666] mt-6">Berperan Memajukan Tegal</h4>
              </div>
              <div className="flex flex-col items-center">
                <img src="/assets/images/icon-center.svg" alt="icon-center" />
                <h4 className="text-[#666666] mt-6">Mengenalkan Budaya dan Wisata</h4>
              </div>
              <div className="flex flex-col items-center">
                <img src="/assets/images/icon-right.svg" alt="icon-right" />
                <h4 className="text-[#666666] mt-6">Mengenalkan Bisnis atau Usahamu</h4>
              </div>
            </div>
            <button className="bg-primary text-white sm:px-11 sm:py-4 px-6 py-2 rounded sm:text-lg text-sm text-center font-medium sm:mt-0 mt-10">
              Jadi Kontributor
            </button>
          </div>
          <div>
            <img src="/assets/images/image-kontributor.png" alt="image-kontributor" />
          </div>
        </div>
        <div className="flex flex-col items-center justify-center text-center mt-28 mb-14">
          <p className="font-medium md:text-5xl text-2xl text-black ">
            Bagaimana Cara Menjadi Kontributor
          </p>
          <p className="md:text-xl text-sm text-[#666666] xl:w-[40%] w-auto mt-5">
            Berikut beberapa beberapa cara untuk menjadi kontributor konten di Explore Tegal
          </p>
        </div>
        <KontributorCard />
      </div>
      <Footer />
    </div>
  );
}
